import { fromJS, List } from 'immutable';

export function request(state) {
    return state.set('STATE', 'IN_PROGRESS');
}

export function finish(state, { permissions, bucket }) {
    let newPermissions = {};

    permissions.forEach(permission => {
        newPermissions[permission.id] = permission;
    });

    return state.updateIn(
        [ 'items' ], oldPermissions => oldPermissions.merge(newPermissions)
    ).setIn(
        [ 'collections', bucket || 'all', 'items' ],
        List(Object.keys(newPermissions))
    ).setIn(
        [ 'collections', bucket || 'all', 'status' ],
        'FINISHED'
    ).set('STATE', 'FINISHED');
}

export function error(state, errors) {
    return state.set('STATE', 'ERROR').set('errors', errors);
}
